export const theme = {
  token: {
    colorPrimary: '#558970',
    colorBgContainer: '#FAFAFAFA',
  },
  components: {
    Button: {
      colorBgContainerDisabled: '#88ac9a',
      colorTextDisabled: '#ffffff',
    },
    Input: {
      colorBgContainerDisabled: '#f5f5f5',
      colorPrimaryHover: '#f5f5f5',
    },
    Menu: {
      colorItemBgSelected: '#F6FFED',
    },
  },
}
